import React from "react";
import { connect } from "react-redux";

import { CustomIcon, Switch, } from "../widgets";
import HelpIcon from "signoxe/images/help-icon.png";
import Cancel from "signoxe/images/cancel.png";

import "./style.scss";
import { callOnEnter } from "signoxe/utils/eventHelpers";
import { updateContentFeed } from "signoxe/actions";
import Icon from "../widgets/Icon/index";
import SelectSearch from "../widgets/SelectSearch";
import { getProfile } from "signoxe/selectors";
import { deviceGroup } from "signoxe/api/schema";

class PlaylistCondition extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonEnable: false,
      helpButton: false,
      freq: null,
      no_item_play: null,
      max_play: null,
      startHour: "",
      startMin: "",
      endHour: "",
      endMin: "",
      buttonVisible: false,
      loading: false,
      match_tags:false
    };

    document.addEventListener("click", function (event) {
      var ignore = document.getElementsByClassName("feed-list")[0];
      var popup = document.getElementsByClassName("playlist-conditions")[0];
      if (ignore && popup) {
        var isClick = ignore.contains(event.target);
        if (!isClick) {
          if(popup != undefined) popup.previousElementSibling.click();
        }
      }
      
    });
  }



  componentDidMount() {
    const { frequency, number_of_item_to_play, max_play_count, start_time, end_time, match_tags } =
      this.props.feed;
    this.setState({
      freq: frequency,
      no_item_play: number_of_item_to_play,
      max_play: max_play_count,
      startHour: start_time.split(":")[0],
      startMin: start_time.split(":")[1],
      endHour: end_time.split(":")[0],
      endMin: end_time.split(":")[1],
      buttonVisible: false,
      match_tags:match_tags,
    });

  }

  getDeviceGroupData() {
    const { start_time, end_time } = this.props.feed;
    this.setState({
      startHour: start_time.split(":")[0],
      startMin: start_time.split(":")[1],
      endHour: end_time.split(":")[0],
      endMin: end_time.split(":")[1],
    });

  }


  cancelConditionsHours = () => {
    this.getDeviceGroupData();
  };


  handleGroupFeedChange = (newFeed) => this.props.setFeed(newFeed);

  handleChange = (field, value) => (e) => {
    this.handleGroupFeedChange({ [field]: value });
  };

  submitConditionHours = () => {
    const { startHour, startMin, endHour, endMin } = this.state;

    if (startHour <= 9) {
      startHour = "0" + startHour;
    }

    if (startMin <= 9) {
      startMin = "0" + startMin;
    }

    if (endHour <= 9) {
      endHour = "0" + endHour;
    }

    if (endMin <= 9) {
      endMin = "0" + endMin;
    }

    let start_time = `${this.state.startHour}:${this.state.startMin}:00`;
    let end_time = `${this.state.endHour}:${this.state.endMin}:00`;

    let operationalData = {
      start_time,
      end_time,
    };

    this.setState({ loading: true });
    this.handleGroupFeedChange(operationalData, (result) => {
      if (result == 400) {
        this.cancelConditionsHours();
      }
      this.setState({ loading: false });
    });
    this.setState({ buttonVisible: false });
  };
  

  render() {
    const first = this.props.first;
    const handleChangeTag = (values) => this.props.onDeviceGroupChange(this.props.deviceGroup.id, { tags: values })
    const isTagsMaching = this.props.profile && this.props.profile.tags_matching 
    
    // GROUP TAG OPTIONS
    let default_deviceTags = []
    if(this.props.deviceGroup.tags){
      default_deviceTags = this.props.deviceGroup.tags
    }
    console.log(this.props.feed)

    var deviceTags_Options = []
    this.props.deviceTags?
    this.props.deviceTags.map((option) => {
        deviceTags_Options.push({label:option.name, value:option.id})
      })
    : null

    return (
      <div className="condition-component">
        <span
          style={{
            marginLeft: "15px",
            alignSelf: "center",
            marginTop: "2px",
            fontSize: "10px",
          }}
          className=" hide-for-mobile button secondary preview-link"
          onClick={() => {
            this.setState({ buttonEnable: !this.state.buttonEnable });
          }}
        >
          {this.props.label}
        </span>
        <span
          className=" hide-for-desktop  preview-link"
          onClick={() => {
            this.setState({ buttonEnable: !this.state.buttonEnable });
          }}
        >
          <Icon
            title="Preview"
            name="cog"
            size="1.3rem"
            margin="21px 0px 6px 8px"
          />


        </span>

        {this.state.buttonEnable && (
          <div className="playlist-conditions" id="conditional-popup">
            <div className="condition-child-data">
              <span>
                Set Type{" "}
                <select disabled value={this.props.feed.type}>
                  <option value="DEFAULT">Default</option>
                  <option value="CAMPAIGN">Campaign</option>
                </select>
              </span>
              <div>
                {/* <Icon
            title="Close"
            name="window-close"
            size="1rem"
            margin="21px 0px 6px 8px"
          /> */}
                <CustomIcon
                  title="Help"
                  path={HelpIcon}
                  onClick={(e) => {
                    this.setState({ helpButton: !this.state.helpButton });
                  }}
                />

                <CustomIcon
                  title="Cancel"
                  path={Cancel}
                  onClick={(e) => {
                    this.setState({ buttonEnable: !this.state.buttonEnable });
                  }}
                />


              </div>
            </div>
            <div className="condition-child">
              <div className="condition-child-data">
                <p>Enter Frequency (mins)</p>{" "}
                <input
                  className="playlist-condition-data"
                  type="number"
                  title="Frequency defines how many times your media will be played."
                  onBlur={this.handleChange(
                    "frequency",
                    this.state.freq == 0 ? -1 : this.state.freq
                  )}
                  onKeyDown={callOnEnter(
                    this.handleChange(
                      "frequency",
                      this.state.freq == 0 ? -1 : this.state.freq
                    )
                  )}
                  value={this.state.freq != -1 && this.state.freq}
                  onChange={(e) => this.setState({ freq: e.target.value })}
                // disabled={first}
                />
              </div>

              {this.state.helpButton && (
                <span className="help-text" style={{ color: "#0a0a0a73" }}>
                  Frequency defines minimum time in minutes after when the
                  campaign can play again.Leave it blank to allow playback
                  everytime.
                </span>
              )}
            </div>

            <div className="condition-child">
              <div className="condition-child-data">
                <p>No of items to pick & play</p>{" "}
                <input
                  className="playlist-condition-data"
                  type="number"
                  title="Defines how many items you want to play."
                  value={this.state.no_item_play}
                  onBlur={this.handleChange(
                    "number_of_item_to_play",
                    this.state.no_item_play < 1 ? -1 : this.state.no_item_play
                  )}
                  onKeyDown={callOnEnter(
                    this.handleChange(
                      "number_of_item_to_play",
                      this.state.no_item_play <= 1 ? -1 : this.state.no_item_play
                    )
                  )}
                  onChange={(e) =>
                    this.setState({ no_item_play: e.target.value })
                  }
                />
              </div>

              {this.state.helpButton && (
                <span className="help-text" style={{ color: "#0a0a0a73" }}>
                  Defines no of media items (amidst all media items in the
                  playlist selected) that are picked (in sequence) to play in an
                  iteration.Leave it blank to play all items.
                </span>
              )}
            </div>

            <div className="condition-child">
              <div className="condition-child-data">
                <p>Max PlayBack count (Per Day)</p>{" "}
                <input
                  className="playlist-condition-data"
                  type="number"
                  title="Max play count is defined as the count of media played."
                  onBlur={this.handleChange(
                    "max_play_count",
                    this.state.max_play <= 0 ? -1 : this.state.max_play
                  )}
                  onKeyDown={callOnEnter(
                    this.handleChange(
                      "max_play_count",
                      this.state.max_play <= 0 ? -1 : this.state.max_play
                    )
                  )}
                  value={this.state.max_play != -1 && this.state.max_play}
                  onChange={(e) => this.setState({ max_play: e.target.value })}
                // disabled={first}
                />
              </div>

              {this.state.helpButton && (
                <span className="help-text" style={{ color: "#0a0a0a73" }}>
                  Defines total cumulative no. of impressions that are allowed
                  for a playlist after which playback for the given playlist
                  will stop.Leave it blank to have no maximum.
                </span>
              )}
            </div>
            
             {isTagsMaching && this.props.deviceGroup.conditional_playback_switch && 
             <Switch
                  label="Play items with matching tags"
                  checked={this.state.match_tags}
                  formId={`match_tags-1`}
                  size="tiny"
                  onChange={(e) => {
                    this.setState({ match_tags: e.target.checked }),
                    this.handleGroupFeedChange({
                      match_tags: e.target.checked,
                    })
                  }}
              />}
            
            <div className="condition-child">
              {/* {
                this.props.profile != undefined && this.props.profile.profile.package.device_tags?
                  <div className="condition-child-data">
                    <p>Tags</p>{" "}
                    <SelectSearch 
                      placeHolder={default_deviceTags}  
                      options={deviceTags_Options} 
                      style={{width:`8rem`, backgroundColor:'white'}}
                      onSelect={ (values)=>  handleChangeTag(values) }
                      name={'Select tag'}
                      id={'SelectTag'}
                      multiple={true}
                    />
                  </div>
                : null
              } */}

              {this.state.helpButton && (
                <span className="help-text" style={{ color: "#0a0a0a73" }}>
                  Only Devices with the corresponding tags as the tag sellected here
                  will have content played on them
                </span>
              )}
            </div>

            <div className="condition-child">

              <div className="operational-hours-view">
                <div className="operational-time">
                  <p>Set duration:</p>
                  <div className="time-inputs">
                    <input
                      type="number"
                      className="playlist-condition-data"
                      disabled={this.state.loading}
                      value={this.state.startHour}
                      onChange={(e) => {
                        let hour = e.target.value;
                        if (hour >= 0 && hour < 24) {
                          this.setState({
                            startHour: hour,
                            buttonVisible: true,
                          });
                        }
                      }}
                    />
                    <span>:</span>
                    <input
                      type="number"
                      className="playlist-condition-data"
                      disabled={this.state.loading}
                      value={this.state.startMin}
                      onChange={(e) => {
                        let min = e.target.value;
                        if (min >= 0 && min < 60) {
                          this.setState({
                            startMin: min,
                            buttonVisible: true,
                          });
                        }
                      }}
                    />
                    <span>-</span>
                    <input
                      type="number"
                      className="playlist-condition-data"
                      disabled={this.state.loading}
                      value={this.state.endHour}
                      onChange={(e) => {
                        let hour = e.target.value;
                        if (hour >= 0 && hour < 24) {
                          this.setState({
                            endHour: hour,
                            buttonVisible: true,
                          });
                        }
                      }}
                    />
                    <span>:</span>
                    <input
                      type="number"
                      className="playlist-condition-data"
                      disabled={this.state.loading}
                      value={this.state.endMin}
                      onChange={(e) => {
                        let min = e.target.value;
                        if (min >= 0 && min < 60) {
                          this.setState({
                            endMin: min,
                            buttonVisible: true,
                          });
                        }
                      }}

                    />
                  </div>
                </div>

                {this.state.loading && (
                  <div className="actions"></div>
                )}

                {this.state.buttonVisible && !this.state.loading && (
                  <div className="actions">
                    <button
                      className="button outline-primary"
                      type="button"
                      onClick={this.cancelConditionsHours}
                    >
                      Cancel
                    </button>
                    <button
                      className="button"
                      type="button"
                      onClick={this.submitConditionHours}
                    >
                      Save
                    </button>
                  </div>
                )}
              </div>
            </div>

          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    state,
    profile: getProfile(state),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setFeed: (value) => dispatch(updateContentFeed(ownProps.feed.id, value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlaylistCondition);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/PlaylistCondition/index.js